import { HttpClient, HttpContext, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, map, mergeMap, throwError } from 'rxjs';
import { API_ACTION, API_SCOPE, ApiAction, ApiScope } from 'src/app/shared/interceptor/interceptor.token';
import { CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { environment as ENV } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentPreviewApi {
  constructor(
    private _http: HttpClient,
    private snackBarService: SnackBarService
  ) {}

  uploadFiles(params: FormData): Observable<any> {
    return this._http
      .post<
        CommonApiResponse<any>
      >(`${ENV.backendBaseUrl}/api/uploadFiles`, params, { context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(
        map((res) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          return res.data;
        }),
        catchError(({ error }: HttpErrorResponse) => {
          this.snackBarService.open('error', error.message);
          return throwError(() => error as CommonApiResponse);
        })
      );
  }

  deleteFile(fileReferenceId: string, propertyId?: string): Observable<any> {
    let httpParams = new HttpParams();

    if (propertyId) {
      httpParams = httpParams.append('propertyId', propertyId);
    }

    return this._http.delete<CommonApiResponse<any>>(`${ENV.backendBaseUrl}/api/file/${fileReferenceId}`, {
      context: new HttpContext().set(API_ACTION, ApiAction.WRITE).set(API_SCOPE, ApiScope.ORDER),
      params: httpParams,
    });
  }

  getFile(url: string): Observable<any> {
    return this._http
      .get(url, {
        responseType: 'blob',
        context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER),
      })
      .pipe(
        catchError(({ error }: HttpErrorResponse) => {
          if (error instanceof Blob) {
            return from(error.text()).pipe(
              mergeMap((text) => {
                try {
                  const commonError = JSON.parse(text) as CommonApiResponse;
                  const errorMessage = commonError.message;
                  this.snackBarService.open('error', errorMessage);
                  return throwError(() => commonError);
                } catch {
                  this.snackBarService.open('error', 'An unknown error occurred');
                  return throwError(() => new Error('Invalid JSON response'));
                }
              })
            );
          } else {
            this.snackBarService.open('error', 'An unknown error occurred');
            return throwError(() => new Error('Unexpected error type'));
          }
        })
      );
  }
}
